import { ReactElement } from "react";

import { ReservationIcons } from "models/Reservation";

export interface ReservationOptionLabelProps {
    field: string
}

export function ReservationOptionIcon({ field }: ReservationOptionLabelProps): ReactElement {
    const icon: string | undefined = {
        inGarden: ReservationIcons.IN_GARDEN,
        isConfirmed: ReservationIcons.IS_CONFIRMED,
        isFirstTime: ReservationIcons.IS_FIRST_TIME,
        isRegularGuest: ReservationIcons.IS_REGULAR_GUEST,
        thisTable: ReservationIcons.THIS_TABLE,
    }[field];

    const color: string | undefined = { isConfirmed: "#ff8575" }[field];

    const indent: string | undefined = { thisTable: "-.25em" }[field];

    return (
        icon
            ?
            <span style={{
                color,
                display: "inline-block",
                marginRight: ".25em",
                textAlign: "center",
                textIndent: indent ?? "none",
                width: "1em",
            }}
            >
                { icon }
            </span>
            :
            <></>
    );
}
